export function countWords(searchTerm: string): number {
    if (!searchTerm) {
        return 0;
    }
    return searchTerm.split(/\s/).length;
}
